"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vuex_class_1 = require("vuex-class");
const vue_property_decorator_1 = require("vue-property-decorator");
const Mapa_vue_1 = __importDefault(require("./resultado/Mapa.vue"));
const Resultados_vue_1 = __importDefault(require("./resultado/Resultados.vue"));
const FiltrosAside_vue_1 = __importDefault(require("./filtros/FiltrosAside.vue"));
let ResultadosBusqueda = class ResultadosBusqueda extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.params = this.paramsIn;
        this.vistaMapa = this.paramsIn.mapa;
        this.vistaFiltros = false;
    }
    created() {
        grecaptcha.ready(() => {
            grecaptcha
                .execute(this.recaptchaSiteKey, {
                action: "homepage",
            })
                .then((token) => {
                this.setRecaptchaToken(token);
            });
        });
    }
    get filtrosCol() {
        return this.vistaMapa ? 2 : 3;
    }
    showMapa() {
        this.vistaMapa = true;
    }
    showFiltros() {
        this.vistaFiltros = !this.vistaFiltros;
    }
    showResultados() {
        this.vistaMapa = false;
    }
};
__decorate([
    vue_property_decorator_1.Prop({ type: Object, required: true }),
    __metadata("design:type", Object)
], ResultadosBusqueda.prototype, "filtros", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Object, required: true }),
    __metadata("design:type", Object)
], ResultadosBusqueda.prototype, "paramsIn", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Number, required: true }),
    __metadata("design:type", Number)
], ResultadosBusqueda.prototype, "centerLat", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Number, required: true }),
    __metadata("design:type", Number)
], ResultadosBusqueda.prototype, "centerLng", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Number, required: false, default: 10 }),
    __metadata("design:type", Number)
], ResultadosBusqueda.prototype, "zoom", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: String, required: false }),
    __metadata("design:type", String)
], ResultadosBusqueda.prototype, "recaptchaSiteKey", void 0);
__decorate([
    vuex_class_1.Mutation("setRecaptchaToken"),
    __metadata("design:type", Object)
], ResultadosBusqueda.prototype, "setRecaptchaToken", void 0);
ResultadosBusqueda = __decorate([
    vue_property_decorator_1.Component({
        components: {
            Mapa: Mapa_vue_1.default,
            Resultados: Resultados_vue_1.default,
            FiltrosAside: FiltrosAside_vue_1.default,
        },
    })
], ResultadosBusqueda);
exports.default = ResultadosBusqueda;
